import React from "react";
import { Navigate } from "react-router-dom";

const SuperAdminRoute = ({ children }) => {
  const role = localStorage.getItem("role");

  if (role !== "SuperAdmin" && role !== "SubAdmin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default SuperAdminRoute;

